import { render, staticRenderFns } from "./DestinationDialog.vue?vue&type=template&id=506e253c&scoped=true&"
import script from "./DestinationDialog.vue?vue&type=script&lang=ts&"
export * from "./DestinationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DestinationDialog.vue?vue&type=style&index=0&id=506e253c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e253c",
  null
  
)

export default component.exports